import type {
    SpendInsightsRequestParams,
    SpendProductRowDto,
} from 'entities/ReportSpendSummary';

export interface SpendDrillInScope {
    propertyIds?: string[];
    categoryIds?: string[];
    supplierIds?: string[];
}

export interface SpendDrillInLocationState {
    scope?: SpendDrillInScope;
    contextTotalSpend?: string;
    propertyName?: string;
    categoryTitle?: string;
    supplierName?: string;
    product?: SpendProductRowDto;
}

export type SpendDrillInDimension = 'property' | 'category' | 'supplier';

export const getSpendCategoryTitle = (
    categoryTitle: unknown,
    fallback: string,
): string => (typeof categoryTitle === 'string' ? categoryTitle : fallback);

export const mergeSpendDrillInScope = (
    current: SpendDrillInScope | undefined,
    next: SpendDrillInScope,
): SpendDrillInScope => {
    const merged: SpendDrillInScope = { ...current };

    if (next.propertyIds?.length) {
        merged.propertyIds = next.propertyIds;
    }
    if (next.categoryIds?.length) {
        merged.categoryIds = next.categoryIds;
    }
    if (next.supplierIds?.length) {
        merged.supplierIds = next.supplierIds;
    }

    return merged;
};

export const buildSpendDrillInRequestParams = ({
    lastRequestParams,
    scope,
    dimension,
    id,
}: {
    lastRequestParams: {
        dateFrom: string;
        dateTo: string;
        propertyIds?: string[];
        categoryIds?: string[];
        supplierIds?: string[];
    };
    scope?: SpendDrillInScope;
    dimension?: SpendDrillInDimension;
    id?: string;
}): SpendInsightsRequestParams => {
    const propertyIds =
        dimension === 'property' && id
            ? [id]
            : scope?.propertyIds ?? lastRequestParams.propertyIds;
    const categoryIds =
        dimension === 'category' && id
            ? [id]
            : scope?.categoryIds ?? lastRequestParams.categoryIds;
    const supplierIds =
        dimension === 'supplier' && id
            ? [id]
            : scope?.supplierIds ?? lastRequestParams.supplierIds;

    return {
        dateFrom: lastRequestParams.dateFrom,
        dateTo: lastRequestParams.dateTo,
        ...(propertyIds?.length ? { propertyIds } : {}),
        ...(categoryIds?.length ? { categoryIds } : {}),
        ...(supplierIds?.length ? { supplierIds } : {}),
    };
};
